<template>
    <div>
        <div class="wscn-http404-container">
            <div class="wscn-http404">
                <div class="pic-404">
                    <img class="pic-404__parent" src="static/picture/common/403.png" alt="404">
                    <img class="pic-404__child left" src="static/picture/common/404_cloud.png" alt="404">
                    <img class="pic-404__child mid" src="static/picture/common/404_cloud.png" alt="404">
                    <img class="pic-404__child right" src="static/picture/common/404_cloud.png" alt="404">
                    <!-- <el-empty description="403"></el-empty> -->
                </div>
                <div class="bullshit">
                    <div class="bullshit__oops">OOPS!</div>
                    <div class="bullshit__info">所有信息均来自
                        <!-- target="_blank" -->
                        <a style="color:#20a0ff" href="/" >山东奥太电气</a>
                    </div>
                    <div class="bullshit__headline">{{ message }}</div>
                    <div class="bullshit__info">对不起,您暂无当前页面访问权限,请联系管理员或点击下方按钮回到首页</div>
                    <router-link class="bullshit__return-home" to="/home">返回首页</router-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'build',
  components: {
  },
  data() {
    return {
      message: '暂无当前页面权限',
      topActive: 0
    }
  },
  created() {
    // this.filterRouter()
  },
  methods: {
    // 左侧菜单和对应上菜单焦点
    filterRouter() {
      let currentRouter = []
      if (this.$route.matched[0]) {
        let parentPath = this.$route.matched[0].path
        let topMenuBar = this.$store.state.permission.topMenuBar
        if (parentPath === '') {
          this.topActive = 0
          return
        }
        for (let j in topMenuBar) {
          if (topMenuBar[j].path.includes(parentPath)) {
            this.topActive = Number(j) + 1
            for (let i in this.routers) {
              if (topMenuBar[j].path.includes(this.routers[i].path)) {
                currentRouter.push(this.routers[i])
              }
            }
            break
          }
        }
        if (currentRouter.length) {
          this.currentRouter = [...currentRouter]
        }
      }
    }
  }
}
</script>

<style lang='less' scoped>
.wscn-http404-container{
    margin-top: 80px;
    transform: translate(-50%,-50%);
    position: absolute;
    top: 50%;
    left: 50%;
}
.wscn-http404 {
    position: relative;
    width: 1200px;
    padding: 0 50px;
    overflow: hidden;
    .pic-404 {
        position: relative;
        float: left;
        width: 600px;
        overflow: hidden;
        &__parent {
            width: 100%;
        }
        &__child {
            position: absolute;
            &.left {
                width: 80px;
                top: 17px;
                left: 220px;
                opacity: 0;
                animation-name: cloudLeft;
                animation-duration: 2s;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
                animation-delay: 1s;
            }
            &.mid {
                width: 46px;
                top: 10px;
                left: 420px;
                opacity: 0;
                animation-name: cloudMid;
                animation-duration: 2s;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
                animation-delay: 1.2s;
            }
            &.right {
                width: 62px;
                top: 100px;
                left: 500px;
                opacity: 0;
                animation-name: cloudRight;
                animation-duration: 2s;
                animation-timing-function: linear;
                animation-fill-mode: forwards;
                animation-delay: 1s;
            }
            @keyframes cloudLeft {
                0% {
                    top: 17px;
                    left: 220px;
                    opacity: 0;
                }
                20% {
                    top: 33px;
                    left: 188px;
                    opacity: 1;
                }
                80% {
                    top: 81px;
                    left: 92px;
                    opacity: 1;
                }
                100% {
                    top: 97px;
                    left: 60px;
                    opacity: 0;
                }
            }
            @keyframes cloudMid {
                0% {
                    top: 10px;
                    left: 420px;
                    opacity: 0;
                }
                20% {
                    top: 40px;
                    left: 360px;
                    opacity: 1;
                }
                70% {
                    top: 130px;
                    left: 180px;
                    opacity: 1;
                }
                100% {
                    top: 160px;
                    left: 120px;
                    opacity: 0;
                }
            }
            @keyframes cloudRight {
                0% {
                    top: 100px;
                    left: 500px;
                    opacity: 0;
                }
                20% {
                    top: 120px;
                    left: 460px;
                    opacity: 1;
                }
                80% {
                    top: 180px;
                    left: 340px;
                    opacity: 1;
                }
                100% {
                    top: 200px;
                    left: 300px;
                    opacity: 0;
                }
            }
        }
    }
    .bullshit {
        position: relative;
        float: left;
        width: 300px;
        padding: 30px 0;
        overflow: hidden;
        &__oops {
            font-size: var(--font-size-30);
            font-weight: bold;
            line-height: 40px;
            color: #1482f0;
            opacity: 0;
            margin-bottom: 20px;
            animation-name: slideUp;
            animation-duration: 0.5s;
            animation-fill-mode: forwards;
        }
        &__headline {
            font-size: var(--font-size-20);
            line-height: 24px;
            color: #222;
            font-weight: bold;
            opacity: 0;
            margin-bottom: 10px;
            animation-name: slideUp;
            animation-duration: 0.5s;
            animation-delay: 0.1s;
            animation-fill-mode: forwards;
        }
        &__info {
            font-size: var(--font-size-16);
            line-height: 21px;
            color: grey;
            opacity: 0;
            margin-bottom: 30px;
            animation-name: slideUp;
            animation-duration: 0.5s;
            animation-delay: 0.2s;
            animation-fill-mode: forwards;
        }
        &__return-home {
            display: block;
            float: left;
            width: 110px;
            height: 36px;
            background: #1482f0;
            border-radius: 100px;
            text-align: center;
            color: #ffffff;
            opacity: 0;
            font-size: var(--font-size-16);
            line-height: 36px;
            cursor: pointer;
            animation-name: slideUp;
            animation-duration: 0.5s;
            animation-delay: 0.3s;
            animation-fill-mode: forwards;
        }
        @keyframes slideUp {
            0% {
                transform: translateY(60px);
                opacity: 0;
            }
            100% {
                transform: translateY(0);
                opacity: 1;
            }
        }
    }
}
</style>
